'use client'
import type { FC, ReactNode } from 'react'
import NextLink from 'next/link'

type Props = {
  href: string,
  // arialabel: string,
  target?: string
  ariaDisabled?: boolean,
  rel?:string,
  locale?: string,
  title?: string,
  className?: string
  children: ReactNode
}

export const Link:FC<Props> = ({ href, target, children, ariaDisabled, rel, locale, title, className }) => {
  return (
    <NextLink href={href} passHref {...locale && { locale }} {...rel && { rel }} {...ariaDisabled && { 'aria-disabled': ariaDisabled }} {...title && { title }} {...className && { className }} {...target && { target }}>
      {children}
    </NextLink>
  )
}
